
import './App.css';
import { HashRouter, BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Home from './Components/HomePage';
import Login from './Components/Login';
import ForgotPassword from './Components/ForgotPassword';
import FAQAccordion from './Components/Faq';
import Products from './Components/ProductComman/Products';
import ProductDetail from './Components/ProductComman/ProductDetail';
import Cart from './Components/Cart';
import Checkout from './Components/Checkout';
import ShippingAddress from './Components/ShippingAddress';
import { useEffect, useState } from 'react';
import CheckToken from './_services/authToken';
import ProductBySubCategoryId from './Components/ProductComman/ProductBySubCategoryId';
import AboutUs from './Components/AboutUs';
import TermsConditions from './Components/TermsConditions';
import PrivacyPolicy from './Components/PrivacyPolicy';
import ContactUs from './Components/ContactUs';
import { WishlistProvider } from './context/wishlistContext';
import SubCategory from './Components/SubCategory';
import UserRegister from './Components/UserRegister';
import PaymentReturn from './Components/PaymentReturn';
import MyProfile from './Components/MyProfile';
import MyOrder from './Components/Orders/MyOrder';
import Blog from './Components/Blog';
import Wishlist from './Components/Wishlist';
import CancelOrder from './Components/Orders/CancelOrder';
import RefundandReturnPolicy from './Components/RefundandReturnPolicy';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ProtectedRoute({ children }) {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  if (!isLoggedIn) {
    const redirectUrl = `${location.pathname}${location.search}${location.hash}`;
    localStorage.setItem("priviousUrl", redirectUrl);
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  return (
    <div className="App">
      <WishlistProvider>
        <BrowserRouter>
          {/* <CheckToken setIsLoggedIn={setIsLoggedIn} /> */}
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/faq" element={<FAQAccordion />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            {/* <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<Products />} /> */}
            <Route path="/products" element={<Products />} />
            <Route path="/products/:categoryId" element={<Products />} /> 
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/:name" element={<SubCategory />} />
            <Route path="/:name/:name" element={<ProductBySubCategoryId />} />
            <Route path="product/:slug" element={<ProductDetail />} />
            <Route path="name/:name/:slug" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/returnandrefundpolicy" element={<RefundandReturnPolicy />} />

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<UserRegister />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/blog" element={<Blog />} />

            {/* {isLoggedIn && ( */}
            <>
              <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
              <Route path="/shipping-address" element={<ProtectedRoute><ShippingAddress /></ProtectedRoute>} />
              <Route path="paymentreturn/:id" element={<PaymentReturn />} />
              {/* <Route path="cash_on_delivery" element={<PaymentReturn />} /> */}
              <Route path="myprofile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
              <Route path="myorder" element={<ProtectedRoute><MyOrder /></ProtectedRoute>} />
              <Route path="wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
              <Route path="cancel-order/:id" element={<ProtectedRoute><CancelOrder /></ProtectedRoute>} />
            </>
            {/* )} */}

            <Route path="*" element={<div>404 - Page Not Found</div>} />
          </Routes>
        </BrowserRouter>
      </WishlistProvider>
    </div>
  );
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

export default App;
